<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-trophy'></i> Quick Tournament List</h3>
              <div class="float-right">
                <b-button variant="primary" @click="showBatchAddModal = true" v-if="checkAccessPrivilege('CMS.Tournament.Quick.BatchUpload')">Batch Add Quick Tournament</b-button>&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button variant="primary" class="float-right" @click="showAddModal = true" v-if="checkAccessPrivilege('CMS.Tournament.Quick.Add')">Add New Quick Tournament</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
              <template v-slot:cell(ImageUrl)="data">
                <img :src="data.item.ImageUrl" width="150px" :alt="data.item.Name"/>
              </template>
              <template v-slot:cell(GameName)="data">
                <div>Platform: <strong>{{ data.item.Brand }}</strong></div>
                <span>Games: {{ data.item.GameName }}</span>
              </template>
              <template v-slot:cell(action)="data">
                <b-button variant="info" @click="updateTournament(data.item)" v-if="checkAccessPrivilege('CMS.Tournament.Quick.Edit')"><i class="icons icon-pencil"></i></b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <AddTournament :brandList="brandList" :showAddModal="showAddModal" @cancelAddTournament="cancelAddTournament"/>
    <UpdateTournament :brandList="brandList" :showUpdateModal="showUpdateModal" :updateData="updateData" @cancelUpdate="cancelUpdateTournament"/>
    <BatchAddTournament :showBatchAddModal="showBatchAddModal" @cancelBatchAdd="cancelBatchAddTournament" />
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import UpdateTournament from './UpdateQuickTournament'
  import AddTournament from './AddQuickTournament'
  import BatchAddTournament from './BatchAddTournament'
export default {
    name: 'withdraw-whitelist-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'Id', label: 'Tournament Id'},
          {key: 'Name', label: 'Name'},
          {key: 'ImageUrl', label: 'Image'},
          {key: 'StartTime', label: 'Start Time'},
          {key: 'EndTime', label: 'End Time'},
          {key: 'EnableTime', label: 'Enable Time'},
          {key: 'DisableTime', label: 'Disable Time'},
          {key: 'GameName', label: 'Games'},
          {key: 'action', label: 'Action'}
        ],
        rowCount: 0,
        currentPage: 1,
        perPage: 15,
        showUpdateModal: false,
        showAddModal: false,
        showBatchAddModal: false,
        updateData: {},
        brandList: []
      }
    },
    components: {
      UpdateTournament,
      AddTournament,
      BatchAddTournament
    },
    watch: {
      currentPage: function () {
        this.getTournamentList()
      }
    },
    methods: {
      getRowCount () {
        return this.rowCount
      },
      async getBrandList () {
        try {
          this.fetchingBrand = true
          let { data } = await this.$http.post(this.API_ENDPOINT + '/game/v2/platform/getList', { headers: { 'Content-Type': 'application/json' } })
          this.brandList = data.list
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          this.fetchingBrand = false
        }
      },
      getTournamentList () {
        this.$http.get(this.API_ENDPOINT + `/tournament/quick/getList?size=${this.perPage}&page=${this.currentPage}`, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
          this.rowCount = response.data.rowCount
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      updateTournament (data) {
        this.showUpdateModal = true
        this.updateData = data
      },
      cancelUpdateTournament () {
        this.showUpdateModal = false
        this.updateData = {}
        this.getTournamentList()
      },
      cancelAddTournament () {
        this.showAddModal = false
        this.getTournamentList()
      },
      cancelBatchAddTournament () {
        this.showBatchAddModal = false
        this.getTournamentList()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      this.getTournamentList()
      this.getBrandList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/tournament/QuickTournament/QuickTournamentTable.vue